import {Component, inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxSelectBoxComponent,
    DxDateBoxComponent,
    DxTagBoxComponent,
    DxCheckBoxComponent, DxNumberBoxComponent,
} from 'devextreme-angular';
import {getSizeQualifier} from 'src/app/services/screen.service';
import {DataSources, DayOfWeek, ShiftDto, ShiftType} from "@services";
import EnumUtils from "../../../../shared/enum-utils";
import {PicturedItemSelectBoxComponent} from "../../../../components";
import { DayOfWeekPipe } from 'src/app/pipes/day-of-week.pipe';

@Component({
    selector: 'shift-form',
    templateUrl: './shift-form.component.html',
    providers: [DataSources, DayOfWeekPipe],
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxSelectBoxComponent,
        DxDateBoxComponent,
        DxTagBoxComponent,
        PicturedItemSelectBoxComponent,
        DxCheckBoxComponent,
        DxNumberBoxComponent,
    ],
})

export class ShiftFormComponent {
    private dataSources = inject(DataSources);
    private dayOfWeekPipe = inject(DayOfWeekPipe);

    @Input() data: ShiftDto = {
        hasMealTicked: false,
        locked: false,
        showInHuddle: false
    } as ShiftDto;

    shiftTypeOptions = EnumUtils.getEnumOptions(ShiftType);
    daysOfWeekOptions = EnumUtils.getEnumOptions(DayOfWeek, (v) => this.dayOfWeekPipe.transform(v));
    supervisorDataSource = this.dataSources.supervisorOptions();
    rolesDataSource = this.dataSources.roleOptions('id');

    getSizeQualifier = getSizeQualifier;

    getData = () => ({...this.data} as ShiftDto)
}
